import { type, value } from '@capital-access/common/user';

export class SuggesterSettings {
  @value(type.array.ofNumber) securities: number[] | null = [];
}
